import React ,  { useEffect , useState} from "react";
import './remove-cities.style.scss';
import {  Button , Modal, Table , Row , Col, message, Typography, Select} from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { loadingAction } from "../../actions/loading-actions";
import { getCities, getViacitiesDetails, reActivateTripRoutesByTripId, getScheduleTripCityAction, recreateScheduleCities } from "../../actions/admin.action";
import { fetchMaterCitiesAction, setTripCityCreated, setTripData } from "../../actions/trip-create.actions";
import moment from "moment";
import { isValidArray, isValidArrayWithValues, isValid } from "../../utils/utilities";

const { Option } = Select;

export const RemoveCities = (props) => {
    const{
        schedule
    } =props;

    const { Text } = Typography;

    const dispatch = useDispatch();
    const history = useHistory();
    const [cities, setCities] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRowKeys	,setSelectedRowKeys	] = useState([]);
    const [selectedNewCity, setSelectedNewCity] = useState(null);
    const masterCities = useSelector(state => state.tripCreateReducer.masterCities);

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const verifyCityValidation = (isRemove,selectedRowKeys) => {
        let cityPosition = [] , isDayOneCityExits = false;
        cities.map((city) => {
            if (selectedRowKeys.includes(city.city) && city.is_active == isRemove) {
                cityPosition.push(city.city);
            }
            if(isRemove && city.day == 0 && (city.is_active == 1 && !selectedRowKeys.includes(city.city))){
                isDayOneCityExits = true;
            }
        });
        return {cityValidation:cityPosition,isDayOneCityExits};
    }

    const formatCityPositioning = (isAdd) => {
        let cityPosition = [];
        cities.map((city) => {
            var isInserted = false;
            if (isAdd) {
                if (selectedRowKeys.includes(city.city) && (city.is_active == false)) {
                    cityPosition.push(city.city);
                    isInserted = true;
                }
            }
            else {
                if (selectedRowKeys.includes(city.city) && (city.is_active)) {
                    isInserted = true;
                }
            }
            if (!isInserted) {
                if (city.is_active) {
                    cityPosition.push(city.city);
                }
            }
        })
        return cityPosition;
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
        },
        selectedRowKeys	:selectedRowKeys
      };


    const getCitiesAction=()=>{
        setLoading(true);
        getViacitiesDetails(schedule.schedule_id,moment(schedule.trip.start_date),(data)=>{
            setCities(getCities(data));
            setLoading(false);
        },()=>{
            setLoading(false);
        },1);
    }

    const updateCityRoute = (isAdd = true) => {
        let {cityValidation,isDayOneCityExits} = verifyCityValidation(!isAdd,selectedRowKeys);
        if(isDayOneCityExits || isAdd){
            if (cityValidation.length!== selectedRowKeys.length) {
                if (isAdd) {
                    message.error("Cannot add cities which is already added.");
                }
                else {
                    message.error("Cannot remove cities which is already removed.");
                }
            }
            else if (selectedRowKeys.length == 0) {
                message.warn("Please select cities to add/remove");
            }
            else {
                let cityPosition = formatCityPositioning(isAdd);
                if (isValidArray(cityPosition)&&cityPosition.length>1) {
                    reActivateTripRoutesByTripId(schedule.trip.id,cityPosition,()=>{
                        setLoading(false);
                        setSelectedRowKeys([]);
                        getCitiesAction();
                        handleOk();
                    },()=>{
                        setLoading(false);
                        handleOk();
                    });
                }
                else{
                    message.warning("Trip should have atleast 2 cities.");
                }
            }
        }else{
            if(!isDayOneCityExits){
                message.warning("Atleast one city should be there in day 1");
            }else{
                message.warning("Unable to perform action.");
            }
        }
    }

    // Master cities that are not already part of the schedule's cities
    const getNewCityOptions = () => {
        if(!isValidArray(masterCities)){
            return [];
        }
        return masterCities.filter((item)=>{
            return !cities.some((city)=> city.city === item.city_name || city.city === item.alias_city_name);
        });
    }

    const startTemporaryCityFlow = (newCity) => {
        setLoading(true);
        recreateScheduleCities(schedule.schedule_id,()=>{
            // tripId so the wizard also loads this trip's existing temporary cities
            getScheduleTripCityAction(schedule.schedule_id,(data)=>{
                dispatch(setTripData(data));
                dispatch(setTripCityCreated(true));
                setLoading(false);
                history.push({
                    pathname:"/trip-create",
                    state:{
                        temporaryCityFlow:true,
                        newCity:{
                            city_name:newCity.city_name,
                            latitude:newCity.latitude,
                            longitude:newCity.longitude
                        },
                        scheduleId:schedule.schedule_id,
                        tripId:schedule.trip.id,
                        startDate:moment(schedule.trip.start_date).format('YYYY-MM-DD')
                    }
                });
            },(err)=>{
                setLoading(false);
                message.error(err);
            },schedule.trip.id);
        },(errMsg)=>{
            setLoading(false);
            message.error(errMsg);
        });
    }

    const onAddNewCity = () => {
        if(!isValid(selectedNewCity)){
            message.warn("Please select a city to add");
            return;
        }
        let newCity = masterCities.find((item)=> item.city_name === selectedNewCity);
        if(!isValid(newCity)){
            message.error("Selected city not found");
            return;
        }
        Modal.confirm({
            title: "Add temporary city",
            content: `${newCity.city_name} is not part of this schedule. Add it as a temporary city for ${moment(schedule.trip.start_date).format('DD-MM-YYYY')} only? You will be taken through the stops and routes pages for the new city.`,
            okText: "Yes, add city",
            cancelText: "No",
            onOk: () => {
                startTemporaryCityFlow(newCity);
            }
        });
    }

    useEffect(()=>{
        getCitiesAction();
        // Fetch master cities for the "add new city" picker (not loaded on this page).
        // Guard with isValidArrayWithValues: isValidArray([]) is true and would skip it.
        if(!isValidArrayWithValues(masterCities)){
            dispatch(fetchMaterCitiesAction());
        }
    },[]);


    return (
        <div>
            <Button
                className="bordered-btn send-driver-details-btn"
                onClick={()=>{
                    showModal();
                }}
            >
                Manage Cities
            </Button>
            <Modal
                    title={"Manage Cities"}
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    footer= {[
                        <Button key="exit" className="exit-btn" onClick= {handleCancel}>Exit</Button>,
                        <Button key="add" onClick = {()=> updateCityRoute(true)}>Add Cities</Button>,
                        <Button key="remove" onClick = {()=> updateCityRoute(false)}>Remove Cities</Button>
                    ]}
                >
                 <Row justify="center" align="center" gutter={[16,16]}>
                    <Col>
                        <Table
                        dataSource={cities}
                        columns={[
                            {
                                title: 'City',
                                dataIndex: 'city',
                                key: 'city',
                                render : (text, record, index) => {
                                    if(isValid(record.is_active)){
                                        if(record.is_temporary){
                                            return  <Text style= {{fontWeight: 'bold'}}>{text} <Text type="warning" style={{fontStyle: 'italic'}}>(temporary)</Text></Text>
                                        }
                                        return  <Text style= {{fontWeight: 'bold'}}>{text}</Text>
                                    }else{
                                        if(record.is_temporary){
                                            // Temp city not activated on the selected day: shown removed, keep the tag.
                                            return  <Text style = {{fontStyle: 'italic'}}>{text} (removed) <Text type="warning">(temporary)</Text></Text>
                                        }
                                        return  <Text style = {{fontStyle: 'italic'}}>{text} (removed)</Text>
                                    }
                                }
                            }
                        ]}
                        rowSelection={rowSelection}
                        pagination={false}
                        rowKey={(record) => {
                            return record.city;
                        }}
                    />
                    </Col>
                 </Row>
                 <Row justify="center" align="middle" gutter={[16,16]} style={{marginTop:16}}>
                    <Col>
                        <Select
                            showSearch
                            allowClear
                            placeholder="Add a new city (temporary)"
                            style={{minWidth:200}}
                            value={selectedNewCity}
                            onChange={(value)=> setSelectedNewCity(value)}
                            filterOption={(input, option) =>
                                option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {getNewCityOptions().map((item)=>(
                                <Option key={item.id} value={item.city_name}>
                                    {item.city_name}{isValid(item.alias_city_name) ? " / " + item.alias_city_name : ""}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                    <Col>
                        <Button onClick={onAddNewCity}>Add New City</Button>
                    </Col>
                 </Row>
            </Modal>
        </div>
    )
}
